import React, { useContext } from 'react'
import { Outlet } from 'react-router-dom'
import { AppContext } from '@/contexts/App'
import { Container } from './App.styles'
import Header from './Header/Header'
import Sidebar from './Sidebar/Sidebar'

const App: React.FC<any> = () => {
  const { isCollapsed } = useContext(AppContext)

  return (
    <Container>
      <Header />

      <main className={`main ${isCollapsed ? 'is-collapsed' : ''}`}>
        <section className="content">
          <Outlet />
        </section>

        <Sidebar />
      </main>
    </Container>
  )
}

export default App
